var map = {
	"./Salaire-FGA-CFDT_qrcode.svg": "ffd4",
	"./burger_menu.svg": "76bd",
	"./en.svg": "bc04",
	"./es.svg": "0815",
	"./feuille.svg": "630b",
	"./fr.svg": "6ed2",
	"./illustration.svg": "4901",
	"./illustration_bas.svg": "8f03",
	"./logo.svg": "9b19",
	"./nuage.svg": "79be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";